import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Modal } from 'antd';
import { Grid, Card } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../i18n/adminI18n';
import MainContainer from '../../../components/MainContainer';
import PopupList from '../../../components/AdminPopup/List/PopupList';
import UpdatePopupModal from '../../../components/AdminPopup/Update/UpdatePopup';

@inject(
    'loginStore',
    'popupStore'
)
@observer
class PopupPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        this.props.loginStore.authenticateAdmin().then(response => {
          if (!response) {
            this.props.history.push('/admin/login');
          }
        });
        
        this.props.popupStore.initPopup();
    }

    componentWillUnmount() {
        this.props.popupStore.setShowUpdatePopupModal(false);
    }

    handleCancelUpdatePopupModal = () => {
        this.props.popupStore.setShowUpdatePopupModal(false);
    }

    handleCancelSearchMenuIteModal = () => {
        this.props.popupStore.setShowSearchMenuItemModal(false);
    }

    render() {
        const { t } = this.props;
        const {
            showUpdatePopupModal,
            managePopupTitle
        } = this.props.popupStore;

        return (
            <MainContainer title={t('Popup Management')} menukey='popups'>
                <Modal
                    title={t(managePopupTitle)}
                    visible={showUpdatePopupModal}
                    width={800}
                    footer={null}
                    onCancel={this.handleCancelUpdatePopupModal}
                    zIndex={1000}
                >
                    <UpdatePopupModal />
                </Modal>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card style={{ height: 980, padding: 20, overflow: 'auto' }}>
                            <PopupList />
                        </Card>
                    </Grid>
                </Grid>
            </MainContainer>
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(PopupPage);